export default __webpack_public_path__ + "static/media/university.b640d6d4.png";